import routerOptions0 from "/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  strict: false,
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}